import Image from 'next/image';

import SliderWrapper from '@/ui/SliderWrapper/SliderWrapper';
import { NextArrow, PrevArrow, SectionTitle, Video } from '@/ui/index';

import styles from './NewsSingle.module.scss';

const NewsSingle = ({
  data: {
    title = '',
    date = '',
    content_sections: contentSections = [],
    images = [],
  },
}) => {
  const options = {
    slidesToShow: 1,
    arrows: true,
    infinite: true,
    nextArrow: <NextArrow brand />,
    prevArrow: <PrevArrow brand />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
        },
      },
    ],
  };

  const renderSlide = (item, key) => {
    return (
      <Image
        src={item?.image}
        alt={item?.title}
        title={item?.title}
        key={key}
        loading='lazy'
        width={1440}
        height={585}
        objectFit='inherit'
      />
    );
  };

  const renderContent = (item, key) => {
    return (
      <>
        {' '}
        <div className={styles.content} key={key}>
          <h2>{item?.title}</h2>
          <div dangerouslySetInnerHTML={{ __html: item?.content }} />
        </div>
        {item?.video_youtube_id && (
          <Video
            video={{
              preview: item?.video_cover,
              videoId: item?.video_youtube_id,
              title: item?.video_title,
            }}
          />
        )}
      </>
    );
  };

  return (
    <>
      <div
        className={`wrapper section ${styles.wrap}`}
        itemScope
        itemType='https://schema.org/ListItem'
      >
        <div className={styles.titleWrap}>
          {!!title && (
            <SectionTitle titleModify={'title--medium'}>{title}</SectionTitle>
          )}
          {!!date && <div className={styles.date}>{date}</div>}
        </div>
        {!!images?.length && (
          <SliderWrapper className={styles.slider} options={options}>
            {images.map(renderSlide)}
          </SliderWrapper>
        )}
      </div>
      {!!contentSections?.length && contentSections.map(renderContent)}
    </>
  );
};

export default NewsSingle;
